import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { Usuario } from "./Usuario";
import Carrito from "./Carrito";
import globals from "../globals";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {useRef} from "react";
import productosStore from "../stores/ProductosStore";
import archivosStore from "../stores/ArchivosStore";
import {isMobile} from "react-device-detect";
import Buscador from "./Buscador";


function Header() {
    const offCanvasRef = useRef();
    const closeOffCanvas = () => {
        if (!offCanvasRef.current.backdrop) return;
        offCanvasRef.current.backdrop.click();
    };
    return (
        <Navbar expand={'lg'} className={'navbar-principal'}>
            <Container fluid className="d-flex bd-highlight mb-0">
                <Navbar.Brand className="me-auto py-2 bd-highlight">
                    <Link to={'/'} className="navbar-brand">
                        {archivosStore.logoWeb &&
                            <img style={{maxHeight: '75px', maxWidth: isMobile ? '230px' : 'unset'}}
                                 src={archivosStore.logoWeb} alt={globals.NOMBRE}/>
                        }
                        {!archivosStore.logoWeb &&
                            <img style={{maxHeight: '75px', maxWidth: isMobile ? '230px' : 'unset'}}
                                 src={globals.PRELOGO} alt={globals.NOMBRE}/>
                        }
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-lg`} />
                <Navbar.Offcanvas
                    id={`offcanvasNavbar-expand-lg`}
                    aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
                    placement="end"
                    ref={offCanvasRef}
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
                            <h4>Menú</h4>
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        {!globals.enContruccion &&
                            <Nav className={'justify-content-end flex-grow-1 pe-3'}>
                                { isMobile &&
                                    <Nav.Item>
                                        <Buscador mobile={true} />
                                    </Nav.Item>
                                }
                                <Nav.Item>
                                    <Link
                                        onClick={closeOffCanvas}
                                        to={'/'} className="nav-link">INICIO</Link>
                                </Nav.Item>
                                {/*
                                { Object.keys(productosStore.categorias).map(cat =>
                                    <Nav.Item>
                                        <Link onClick={closeOffCanvas}
                                            to={'/' + cat} className="nav-link">{cat}</Link>
                                    </Nav.Item>
                                )}
                                */}
                                { globals.LINKS.map(link =>
                                    <Nav.Item>
                                        <Link onClick={closeOffCanvas}
                                              to={link.to} className="nav-link">{link.name}</Link>
                                    </Nav.Item>
                                )}
                                <Nav.Item>
                                    <a
                                        onClick={closeOffCanvas}
                                        className="nav-link" href="#contacto">Contacto</a>
                                </Nav.Item>
                                <Nav.Item className="mobile mt-auto logo-navbar-mb">
                                    <img src={archivosStore.logoWeb} alt={globals.NOMBRE} />
                                </Nav.Item>
                            </Nav>
                        }
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
                {!globals.enContruccion && !globals.soloCatalogo &&
                    <Usuario className="py-2 bd-highlight" />
                }
                {!globals.enContruccion && !globals.soloCatalogo &&
                    <Carrito />
                }
            </Container>
        </Navbar>
    );
}
export default observer(Header);